<template>
	<div class="message-bubble">
		<v-card v-if="!delivery">
			<v-container>
				<v-row class="delivery-row" @click="pickupPayment"
					><v-col><v-btn class="button-rounding">Iré a recogerlo</v-btn></v-col></v-row
				>
				<v-row class="delivery-row" @click="setDelivery('delivery')"
					><v-col><v-btn class="button-rounding">Envíalo a mi ubicación</v-btn></v-col></v-row
				>
			</v-container>

			<v-card-actions>
				<BackBtn :return_to="'cart'" :text="true" />
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
		<v-card v-if="delivery === 'delivery' && !selectedOption">
			<v-container>
				<v-row
					class="delivery-row"
					@click="showOptions(own_delivery_services)"
					v-if="own_delivery_services"
					><v-col> <v-btn class="button-rounding"> Nuestro delivery </v-btn> </v-col></v-row
				>
				<v-row
					class="delivery-row"
					@click="showOptions(company.prices, true, company.id)"
					v-for="(company, index) in external_delivery_services"
					:key="index"
				>
					<v-col>
						<v-btn class="button-rounding">{{ company.name }}</v-btn>
					</v-col>
				</v-row>
			</v-container>

			<v-card-actions>
				<v-btn class="bot-btn-action button-rounding" dark @click="setDelivery(null)">
					<v-icon left>mdi-arrow-left-bold</v-icon>
					Otras opciones
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
		<v-card v-if="delivery === 'delivery' && selectedOption">
			<v-container>
				<v-row
					class="delivery-row"
					v-for="(item, index) in selectedOption"
					:key="index"
					@click="deliveryPayment(item)"
				>
					<v-col>
						<v-btn class="button-rounding">{{ item.destination_city || item.city }} </v-btn>
						<p>{{ getPrice(item) }}</p>
					</v-col>
				</v-row>
			</v-container>
			<v-card-actions>
				<v-btn class="bot-btn-action button-rounding" dark @click="showOptions(null)">
					<v-icon left>mdi-arrow-left-bold</v-icon>
					Otras opciones
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	data() {
		return {
			delivery: null,
			selectedOption: null,
			company_id: null,
		};
	},
	computed: {
		own_delivery_services() {
			return this.$store.getters[
				"chatStore/get_store_data"
			].delivery_prices.filter((item) => item !== null);
		},
		external_delivery_services() {
			return this.$store.getters[
				"chatStore/get_store_data"
			].deliveries_companies.filter((item) => item !== null);
		},
		store_city() {
			return this.$store.getters["chatStore/get_store_data"].address.city;
		},
	},
	methods: {
		showOptions(option = null, external = false, company_id = null) {
			this.$store.commit("chatStore/UPDATER"); //used to update parent component in order to scroll to bottom of chat
			if (!option) {
				this.selectedOption = null;
				return;
			}

			this.company_id = company_id;

			let filteredOption = [...option];
			if (external) {
				filteredOption = filteredOption.filter((option) => {
					//display only options for the same city as the store
					//i.e. the store is located in Lecheria, display only rates from lecheria to X
					return option.city == this.store_city;
				});
			}

			this.selectedOption = filteredOption;
		},
		setDelivery(type) {
			this.$store.commit("chatStore/UPDATER"); //used to update parent component in order to scroll to bottom of chat
			this.delivery = type;
		},
		pickupPayment() {
			this.$store.commit("chatStore/SET_DELIVERY", null);
			this.$store.commit("chatStore/STATUS", "banks");
		},
		deliveryPayment(selectedDelivery) {
			this.$store.dispatch("chatStore/delivery_payment_process", {
				delivery: selectedDelivery,
				company_id: this.company_id,
			});
		},
		getPrice(item) {
			let price = "";
			if (item.percent > 0) {
				price += `${item.percent}% de la compra`;
			}
			if (item.percent > 0 && item.price > 0) {
				price += ` + `;
			}
			if (item.price > 0) {
				price += `$${item.price}`;
			}
			if (item.price == 0 && item.percent == 0) {
				price += "Gratis";
			}

			return price;
		},
	},
};
</script>

<style lang="scss">
.delivery-row {
	&:hover {
		background-color: #eee;
		cursor: pointer;
	}
}
.delivery-row button {
	color: var(--app-button-text) !important;
	background-color: var(--secondary-app-button) !important;
}
</style>
